import React from "react";
import PageBuilder from "../../components/PageBuilder/PageBuilder";
import { useSanityContent } from "../../hooks/useSanityContent";
import { PAGE_QUERY } from "../../sanity/queries";
import { homeFallbackSections } from "../../content/home.fallback";

export default function Home() {
  const { data } = useSanityContent(PAGE_QUERY("home"), { sections: homeFallbackSections });
  return <PageBuilder sections={data.sections} documentId={data._id} />;
}
